import React from "react";
import CurrentProject from "../components/Now/CurrentProjects";
import Contact from "../components/Contact/Contact";
export default function NowPage(){
    return(
    <div>
        <h1>What I'm up to now..</h1>
        <CurrentProject/>

        <Contact/>
    </div>
    );
}